export type RemediationJourneyParams = {
  sessionId: string
  standardCode?: string
  controlKey?: string
  mode?: 'remediation' | 'assessment'
}

export function buildRemediationJourneyUrl(params: RemediationJourneyParams): string {
  const q = new URLSearchParams()
  q.set('sessionId', params.sessionId)
  if (params.standardCode) q.set('standardCode', params.standardCode)
  if (params.controlKey) q.set('controlKey', params.controlKey)
  if (params.mode) q.set('mode', params.mode)
  return `/compliance-center/assessments?${q.toString()}`
}

export function parseRemediationJourneySearch(search: string): {
  sessionId: string | null
  standardCode: string | null
  controlKey: string | null
  mode: string | null
} {
  const q = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  return {
    sessionId: q.get('sessionId'),
    standardCode: q.get('standardCode'),
    controlKey: q.get('controlKey'),
    mode: q.get('mode'),
  }
}

export type RemediationFilterTab = 'ALL' | 'FAILED' | 'PARTIAL' | 'EVIDENCE_GAP' | 'PENDING_EVIDENCE' | 'NEEDS_REVIEW'

export function filterControlsByRemediationTab<T extends { status?: string; unresolvedStatus?: string }>(
  controls: T[],
  tab: RemediationFilterTab,
): T[] {
  if (tab === 'ALL') return controls
  if (tab === 'NEEDS_REVIEW') {
    return controls.filter((c) => {
      const s = String(c.status || c.unresolvedStatus || '').toUpperCase()
      return s === 'PARTIAL' || s === 'PENDING_EVIDENCE'
    })
  }
  return controls.filter((c) => String(c.status || c.unresolvedStatus || '').toUpperCase() === tab)
}

export function resolveRemediationResumeControlKey(
  controls: Array<{ controlKey: string; status?: string; unresolvedStatus?: string }>,
  options: {
    urlControlKey?: string | null
    savedControlKey?: string | null
  },
): string | null {
  if (options.urlControlKey) {
    const hit = controls.find((c) => c.controlKey === options.urlControlKey)
    if (hit) return hit.controlKey
    return options.urlControlKey
  }
  if (options.savedControlKey) {
    const hit = controls.find((c) => c.controlKey === options.savedControlKey)
    if (hit) return hit.controlKey
  }
  return controls[0]?.controlKey || null
}
